// App Routes

import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "../pages/landing/LandingPage";
import AdminPage from "../pages/admin/AdminPage";
import CheckInPage from "../features/checkIn/pages/CheckInPage";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/check-in" element={<CheckInPage />} />
      </Routes>
    </BrowserRouter>
  );
}